import Image from "next/image";
import { cn } from "@/lib/utils";

export function PandaBrandLogo({
  className,
  innerClassName,
}: {
  className?: string;
  innerClassName?: string;
}) {
  return (
    <div
      className={cn(
        "clickable-element bubble-element Image baTaIzaP inline-flex items-center min-h-0 max-h-none",
        className,
      )}
      style={{ minHeight: "unset", maxHeight: "unset" }}
    >
      {/* Light mode logo */}
      <div
        className={cn(
          "aspect-[1074/370] w-[min(112px,calc(100vw-9rem))] shrink-0 sm:w-[128px] md:w-[140px] dark:hidden",
          innerClassName,
        )}
      >
        <Image
          src="/panda_logo_light.svg"
          alt="Panda"
          width={1074}
          height={370}
          className="h-full w-full object-contain object-left"
          priority
        />
      </div>
      {/* Dark mode logo */}
      <div
        className={cn(
          "hidden aspect-[1074/370] w-[min(112px,calc(100vw-9rem))] shrink-0 sm:w-[128px] md:w-[140px] dark:block",
          innerClassName,
        )}
      >
        <Image
          src="/panda_logo_dark.svg"
          alt="Panda"
          width={1074}
          height={370}
          className="h-full w-full object-contain object-left"
          priority
        />
      </div>
    </div>
  );
}
